import { schemaTypes, dateFormat } from "../../../constants/constants";
import ReportAPIs from "../../../APIs/ReportAPIs";
import { JSONToCSVConvertor, stripLoc } from "../../../helpers/helperFunctions";
import momentTZ from "moment-timezone";
import {
  canShowRangeSwitch,
  changeVehicle,
} from "./historyReport/historyReport";
import moment from "moment";
import _ from "lodash";
import { isEvGroup } from "../reports/summaryReport";
import actions from "../../../store/actions";
// import { processData } from "./dailyReport";
import { changeToHours } from "../reports/aggregatedReport";
let hours = {
  0: { key: "00:00", name: "00:00 - 01:00" },
  1: { key: "01:00", name: "01:00 - 02:00" },
  2: { key: "02:00", name: "02:00 - 03:00" },
  3: { key: "03:00", name: "03:00 - 04:00" },
  4: { key: "04:00", name: "04:00 - 05:00" },
  5: { key: "05:00", name: "05:00 - 06:00" },
  6: { key: "06:00", name: "06:00 - 07:00" },
  7: { key: "07:00", name: "07:00 - 08:00" },
  8: { key: "08:00", name: "08:00 - 09:00" },
  9: { key: "09:00", name: "09:00 - 10:00" },
  10: { key: "10:00", name: "10:00 - 11:00" },
  11: { key: "11:00", name: "11:00 - 12:00" },
  12: { key: "12:00", name: "12:00 - 13:00" },
  13: { key: "13:00", name: "13:00 - 14:00" },
  14: { key: "14:00", name: "14:00 - 15:00" },
  15: { key: "15:00", name: "15:00 - 16:00" },
  16: { key: "16:00", name: "16:00 - 17:00" },
  17: { key: "17:00", name: "17:00 - 18:00" },
  18: { key: "18:00", name: "18:00 - 19:00" },
  19: { key: "19:00", name: "19:00 - 20:00 " },
  20: { key: "20:00", name: "20:00 - 21:00" },
  21: { key: "21:00", name: "21:00 - 22:00" },
  22: { key: "22:00", name: "22:00 - 23:00" },
  23: { key: "23:00", name: "23:00 - 23:59" },
};

const processData = (respObj, vehicleMap, callback) => {
  let historyData = [];
  // let locationbodyfrom = [];
  // let locationbodyto = [];
  for (let vehiclepath in respObj) {
    let vehicleno = vehicleMap[vehiclepath].vehicleno;
    for (let ridx in respObj[vehiclepath]) {
      let eachitem = respObj[vehiclepath][ridx];
      let starttime =
        eachitem.starttime != null ? new Date(eachitem.starttime) : null;
      let endtime =
        eachitem.endtime != null ? new Date(eachitem.endtime) : null;
      let status = eachitem.status ? eachitem.status : null;
      let distance = eachitem.distance ? eachitem.distance : null;
      historyData.push({
        vehicleno,
        starttime,
        endtime,
        status,
        distance,
      });
    }
  }
  callback(historyData);
};
const getHistory = (schema, data, store) => {
  // let starttime = data.starttime.unix() * 1000;
  let startDate = window.hourlyStartTime.format("DD/MM/YYYY");
  let hour = data.hours.length ? data.hours[0].id : [];
  window.selectedHour = data.hours;
  if (!hour.length) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Please select hour",
        content: "Please select hour",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    return;
  }
  let combinedTime = startDate + "" + hour;
  let starttime = moment(combinedTime, "DD/MM/YYYY HH:mm");
  starttime = starttime.valueOf();
  let endtime = starttime + 60 * 60 * 1000;
  let currenttime = new Date().getTime();
  if (starttime >= currenttime) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Please select valid time",
        content: "The start time should be less than current time.",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    return;
  }
  // console.log(store)
  let vehicles = [];
  for (let idx in store.vehicleMap) {
    vehicles.push(store.vehicleMap[idx].vehicleid);
  }
  // console.log(vehicles)
  // let endtime = data.endtime.unix() * 1000;
  let saveState = null;
  let tableStateData = null;
  // if (!data.vehicle.length) {
  //   store.dispatch({
  //     type: "ADD_INTOAST",
  //     data: {
  //       name: "Please select a vehicle",
  //       content: "Please select a vehicle",
  //       createAt: Date.now(),
  //       autoClose: 8000,
  //     },
  //   });
  //   return;
  // }
  // if (endtime - starttime > 1000 * 60 * 60 * 24 * 7) {
  //   store.dispatch({
  //     type: "ADD_INTOAST",
  //     data: {
  //       name: "You can't select a date range of more than 7 days",
  //       content: "You can't select date range of more than 7 days",
  //       createAt: Date.now(),
  //       autoClose: 8000,
  //     },
  //   });
  //   return;
  // }
  // if (starttime >= endtime) {
  //   store.dispatch({
  //     type: "ADD_INTOAST",
  //     data: {
  //       name: "Start time should be less than the end time",
  //       content: "Start time should be less than the end time",
  //       createAt: Date.now(),
  //       autoClose: 8000,
  //     },
  //   });
  //   return
  // }
  if (vehicles && vehicles.length) {
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, true);
    // let vehicleIds = data.vehicle.map((vehicle) => {
    //   return vehicle.id
    // })
    let body = {
      vehicleid: vehicles,
      starttime: starttime,
      endtime: endtime,
    };
    if (schema.content[0].ref) {
      schema.content[0].ref.setBusy(true);
      saveState = schema.content[0].ref.props.saveState;
      tableStateData = [
        schema.content[0].ref.state,
        schema.content[0].ref.props.schemaKey,
        schema.content[0].ref.props.data,
      ];
    }
    ReportAPIs.hourlyDistance(body)
      .then((resp) => {
        // console.log("resp",resp)
        window.dataForAll = resp;
        window.dataForAll = resp;
        if (window.setReportWindowTabBusy)
          window.setReportWindowTabBusy(schema, false);
        processData(resp, store.vehicleMap, (data) => {
          if (tableStateData && tableStateData[0]) {
            tableStateData[0].body = data;
            tableStateData[0].busy = false;
            saveState(tableStateData[0], tableStateData[1], tableStateData[2]);
          }
          if (schema.content[0].ref) {
            schema.content[0].ref.setData(data);
          }
        });
      })
      .catch(() => {
        console.log("something went wrong");
        if (window.setReportWindowTabBusy)
          window.setReportWindowTabBusy(schema, false);
        schema.content[0].ref.setBusy(false);
      });
  }
};
const download = (schema) => {
  if (schema.content[0].ref) {
    JSONToCSVConvertor(
      schema.content[0].ref.getData(true),
      "hourly Report",
      false
    );
  }
};
const schema = {
  key: "hourly_report",
  name: "Hourly Status Report",
  toolbar: [
    // {
    //   key: "vehicle",
    //   type: schemaTypes.MULTI_SELECT,
    //   singleSelect:true,
    //   storeData: (state) => {
    //     return {
    //         data: (() => {
    //           let newMap = {};
    //           for (let idx in state.vehicleMap) {
    //             if (idx.indexOf("user") === -1) {
    //               newMap[idx] = state.vehicleMap[idx];
    //             }
    //           }
    //           return newMap;
    //         })(),
    //         name: "vehicleno",
    //         id: "vehicleid",
    //       };
    //   },
    //   maxCount: 6000,
    //   onItemChange: changeVehicle.bind(this),
    //   defaultValue: () => {
    //     return {
    //       data: window.selectedVehicles.map((i) => {
    //         return i.id;
    //       }),
    //       updatedAt: window.selectedVehiclesUpdatedAt,
    //     };
    //   },
    // },
    {
      key: "starttime",
      type: schemaTypes.DATE_PICKER2,
      setIfNull: true,
      placeholder: "Start Date",
      // model: Date.now() - 1000 * 60 * 60 * 24,
      hideTime: true,
      schemaKey: "hourly_report",
    },
    {
      key: "hours",
      placeholder: "Select hour",
      type: schemaTypes.MULTI_SELECT,
      onItemChange: (data) => {
        window.selectedHour = data;
      },
      singleSelect: true,
      storeData: (state) => {
        return {
          data: hours,
          name: "name",
          id: "key",
        };
      },
    },
    // {
    //   key: "endtime",
    //   type: schemaTypes.DATE_PICKER,
    //   setIfNull: true,
    //   placeholder: "End Date",
    //   model: Date.now() - 1000 * 60,
    //   // hideTime: true,
    //   schemaKey: "hourly_report",
    // },
    {
      key: "get_history",
      type: schemaTypes.BUTTON,
      name: "Get Hourly Status Report",
      onClick: getHistory,
    },
    {
      key: "download",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-download",
      onClick: download,
      tooltip: "Download Page",
    },
  ],
  content: [
    {
      key: "dataTable",
      type: schemaTypes.IN_TABLE,
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
      head: [
        {
          key: "vehicleno",
          name: "Vehicle No",
        },
        {
          key: "starttime",
          name: "Start Time",
          type: "DATE",
          format: dateFormat,
          width: 1.5,
        },
        {
          key: "endtime",
          name: "End Time",
          type: "DATE",
          format: dateFormat,
          width: 1.5,
        },
        { key: "distance", name: "Distance" },
        { key: "status", name: "Status" },
      ],
    },
  ],
};
export default schema;
